/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyProcessSubtheme = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategyProcessSubtheme model module.
   * @module model/StrategyProcessSubtheme
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyProcessSubtheme</code>.
   * @alias module:model/StrategyProcessSubtheme
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>StrategyProcessSubtheme</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyProcessSubtheme} obj Optional instance to populate.
   * @return {module:model/StrategyProcessSubtheme} The populated <code>StrategyProcessSubtheme</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ThemeID')) {
        obj['ThemeID'] = ApiClient.convertToType(data['ThemeID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('WorkshopID')) {
        obj['WorkshopID'] = ApiClient.convertToType(data['WorkshopID'], 'Integer');
      }
      if (data.hasOwnProperty('MeetingTemplateID')) {
        obj['MeetingTemplateID'] = ApiClient.convertToType(data['MeetingTemplateID'], 'Integer');
      }
      if (data.hasOwnProperty('ExternalURL')) {
        obj['ExternalURL'] = ApiClient.convertToType(data['ExternalURL'], 'String');
      }
      if (data.hasOwnProperty('FileName')) {
        obj['FileName'] = ApiClient.convertToType(data['FileName'], 'String');
      }
      if (data.hasOwnProperty('MimeType')) {
        obj['MimeType'] = ApiClient.convertToType(data['MimeType'], 'String');
      }
      if (data.hasOwnProperty('BlobStorageURL')) {
        obj['BlobStorageURL'] = ApiClient.convertToType(data['BlobStorageURL'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} ThemeID
   * @default 0
   */
  exports.prototype['ThemeID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} WorkshopID
   */
  exports.prototype['WorkshopID'] = undefined;
  /**
   * @member {Integer} MeetingTemplateID
   */
  exports.prototype['MeetingTemplateID'] = undefined;
  /**
   * @member {String} ExternalURL
   * @default ''
   */
  exports.prototype['ExternalURL'] = '';
  /**
   * @member {String} FileName
   * @default ''
   */
  exports.prototype['FileName'] = '';
  /**
   * @member {String} MimeType
   * @default ''
   */
  exports.prototype['MimeType'] = '';
  /**
   * @member {String} BlobStorageURL
   * @default ''
   */
  exports.prototype['BlobStorageURL'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


